import { render } from "./ImportacionAsistente.vue?vue&type=template&id=bc94b19e&scoped=true"
import script from "./ImportacionAsistente.vue?vue&type=script&lang=js"
export * from "./ImportacionAsistente.vue?vue&type=script&lang=js"

import "./ImportacionAsistente.vue?vue&type=style&index=0&id=bc94b19e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc94b19e"]])

export default __exports__